import React, { Component } from "react";
import ErrorComponent from "./error-box";
import { membershipImages } from "../../common/images";

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      membershipItem: props.membershipItem || "Membership",
      errorMessage: props.message || "An unexpected error occurred.",
    };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ membershipItem: this.props.membershipItem,  errorMessage: error.message });
  }
  render() {
    // console.log(this.state.membershipItem)
    if (this.state.hasError) {
      return (
        <div className="container mx-auto xs:px-3.5 laptop:px-4">
          <div className="register-wrapper">
            <ErrorComponent
              onClick={() => window.location.reload()}
              membership={this.state.membershipItem}
              errorMessage={this.state.errorMessage}
            />
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
